<template>
  <div>
    <div v-show="showMobile" class="add-to-cart-mobile">
      <ProductAddToCart
        :mobile="true"
        :product="product"
        :quantity="quantity"
        @set-quantity="setQuantity"
      />
    </div>
    <div class="add-to-cart-mid-page">
      <ProductAddToCart
        :product="product"
        :quantity="quantity"
        @set-quantity="setQuantity"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ProductAddToCart: defineAsyncComponent(
      () => import('@/components/Product/PDP/ProductAddToCart'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    showMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quantity: 1,
    }
  },
  methods: {
    setQuantity(newValue) {
      this.quantity = newValue
    },
  },
}
</script>
